<template>
    <div class="container-fluid">
        <Breadcrumb title="Add Socks Proxy" v-bind:button-show="false" v-show="!id"></Breadcrumb>
        <Breadcrumb v-bind:title="'Edit Socks Proxy #' + id" v-bind:button-show="false" v-show="id"></Breadcrumb>

        <div class="row" style="position: relative">
            <div class="col-12 row-preloader" v-if="id">
                <Preloader v-bind:class="{preloader: loading}" v-show="loading"></Preloader>
            </div>
            <div class="col-12" v-show="!loading">
                <div class="card" v-if="!id">
                    <div class="card-body">
                        <div class="form-group" v-if="uploadingFiles.length">
                            <h5>Now uploading files:</h5>
                            <div v-for="(list, index) in uploadingFiles" :key="index">
                                <h3 class="mb-1 mt-3" style="font-size:18px;">
                                    {{list.label}}
                                    <span style="float:right;">{{list.completion}}</span>
                                </h3>
                                <div class="progress-bar bg-info" role="progressbar"
                                     v-bind:style="{width: list.completion, height: '3px'}"
                                     aria-valuenow="30" aria-valuemin="0" aria-valuemax="100">
                                </div>
                            </div>
                        </div>
                        <div class="form-group mb-0">
                            <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                    @click="uploadCardView = true">
                                <i class="fas fa-upload"></i>
                                Upload a list of Socks
                            </button>
                        </div>
                    </div>
                </div>
                <transition name="bounce">
                    <div class="card" v-if="!id" v-show="uploadCardView" :key="$route.fullPath">
                        <div class="card-body">
                            <button type="button" class="close" aria-label="Close" @click="uploadCardView = false">
                                <span aria-hidden="true">&times;</span>
                            </button>
                            <div>
                                <div class="form-group">
                                    <h4>Upload a list of Socks</h4>
                                    <small class="form-text text-muted mt-0">
                                        <br/>
                                        Header is required. Field separator is colon. Login and password fields are
                                        optional. Example:<br/>
                                        ip:port:login:password<br/>
                                        127.0.0.1:12345:user:asdfg<br/>
                                        192.168.0.1:54321:user:qwerty<br/>
                                    </small>
                                </div>
                                <div class="form-group text-left" v-if="isAdmin">
                                    <label>Select socks owner</label>
                                    <treeselect placeholder="Select User"
                                                v-model="owner"
                                                :multiple="false"
                                                :options="userList"
                                                :load-options="loadUserList"
                                                value-format="object"
                                    />
                                </div>
                                <div class="form-group text-left">
                                    <label for="socksProxies">Select socks file</label>
                                    <input type="file" id="socksProxies" accept="text/csv" class="w-100"/>
                                </div>
                                <button type="button" class="btn btn-success btn-rounded mr-2 mb-2"
                                        @click="listUpload">
                                    <i class="fas fa-upload"></i>
                                    Upload
                                </button>
                            </div>
                        </div>
                    </div>
                </transition>
                <div class="card">
                    <div class="card-body">
                        <SocksProxyForm :id="id" @hidePreloader="hidePreloader"></SocksProxyForm>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Preloader from '../components/Preloader';
    import SocksProxyForm from './forms/SocksProxyForm';
    import SocksProxyService from '../services/SocksProxyService';
    import Breadcrumb from '../components/Breadcrumb';
    import Swal from 'sweetalert2';
    import Treeselect from '@riophae/vue-treeselect';
    import UserService from '../services/UserService';
    import AuthService from '../services/AuthService';
    import UploadFileService from '../services/UploadFileService';
    import config from '../config';
    import {mapGetters} from 'vuex';
    import {FileType} from '../constants';

    export default {
        name: 'SocksProxy',
        props: ['id'],
        components: {
            Preloader, SocksProxyForm, Breadcrumb, Treeselect
        },
        data() {
            return {
                loading: false,
                uploadCardView: false,
                userList: null,
                userId: AuthService.tokenDecode(AuthService.getToken()).id,
                isAdmin: this.$store.getters.isAdmin,
                owner: null,
                uploadingFiles: []
            }
        },
        mounted() {
            if (this.id) {
                this.loading = true;
            } else {
                this.getUploadingFiles();
                this.listUploadProgress();
            }
        },
        computed: {
            ...mapGetters({mercureListen: 'listen'})
        },
        methods: {
            hidePreloader(value) {
                this.loading = value
            },
            loadUserList({callback}) {
                UserService.getUserSelect().then(response => {
                    this.userList = response.data['hydra:member'].map(user => {
                        return {id: user.id, label: user.username}
                    });
                    callback();
                });
            },
            listUpload() {
                let data = new FormData();
                data.append('socksProxies', document.getElementById('socksProxies').files[0]);
                if (this.owner !== null) {
                    data.append('userId', this.owner.id);
                }
                SocksProxyService.uploadSocksProxies(data).then(response => {
                    if (response.status === 200) {
                        Swal({
                            type: 'success',
                            title: 'File is accepted for processing',
                            text: 'It will take some time to process the data, please wait.'
                        });
                        this.getUploadingFiles();
                        this.uploadCardView = false;
                    } else {
                        Swal({
                            type: 'error',
                            title: 'Error',
                            text: response.data.error !== undefined ? response.data.error : 'Some error occurred.'
                        })
                    }
                });

            },
            listUploadProgress() {
                if (!this.mercureListen.hasOwnProperty(config.uploadSocksProgressStatus)) {
                    let url = new URL(config.mercureHubUrl);
                    url.searchParams.append('topic', config.uploadSocksProgressStatus);
                    let eventSource = new EventSource(url);
                    this.$store.commit('setListening', {[config.uploadSocksProgressStatus]: eventSource});
                }
                this.mercureListen[config.uploadSocksProgressStatus].onmessage = event => {
                    let data = JSON.parse(event.data);
                    if (data.fileId !== undefined) {
                        let index = this.uploadingFiles.findIndex(file => file.id === data.fileId);
                        if (index < 0) {
                            return;
                        } else {
                            this.uploadingFiles[index].completion = parseInt(data.completion) + '%';
                        }
                        if (data.error !== undefined) {
                            this.$snotify.error('File ' + this.uploadingFiles[index].label + ' processing error: ' + data.error);
                            this.uploadingFiles.splice(index, 1);
                            return;
                        }
                        if (100 === parseInt(data.completion)) {
                            this.$snotify.success('File ' + this.uploadingFiles[index].label + ' processing completed! Uploaded ' + data.createdCount + ' socks.');
                            this.uploadingFiles.splice(index, 1);
                        }
                    }
                }
            },
            getUploadingFiles() {
                UploadFileService.getFiles(FileType['SOCKS']).then(response => {
                    if (response.status === 200) {
                        this.uploadingFiles = response.data['hydra:member'].map(file => {
                            return {id: file.id, label: file.originalName, completion: '0%'}
                        });
                    }
                });
            }
        }
    }
</script>

<style scoped>
    .bounce-enter-active {
        animation: bounce-in .8s;
    }

    .bounce-leave-active {
        animation: bounce-in .5s reverse;
    }

    @keyframes bounce-in {
        0% {
            transform: scale(0.5);
        }
        50% {
            transform: scale(1.1);
        }
        100% {
            transform: scale(1);
        }
    }
</style>
